/**
 * Plan picker — drives the product form's variant id + selling_plan
 * from a single flat list of variant×plan combos.
 */
class PlanPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.formId = this.dataset.formId;
    this.sectionId = this.dataset.section;
    this.addEventListener('change', this.onChange.bind(this));

    // Defer initial selection so <variant-radios> finishes its own
    // connectedCallback first — otherwise our change event fires before
    // the theme's listeners are attached, and the Add to Cart button
    // never gets enabled.
    requestAnimationFrame(() => {
      const first = this.querySelector('input[type="radio"]:not(:disabled)');
      if (first && !this.querySelector('input[type="radio"]:checked')) {
        first.checked = true;
        this.applySelection(first);
      }
    });
  }

  onChange(event) {
    if (event.target.matches('input[type="radio"]')) {
      this.applySelection(event.target);
    }
  }

  applySelection(radio) {
    const variantId = radio.dataset.variantId;
    const variantOption = radio.dataset.variantOption;
    const planId = radio.dataset.planId || '';
    const form = document.getElementById(this.formId);
    if (!form) {
      console.warn('[plan-picker] product form not found:', this.formId);
      return;
    }

    // 1. Set variant id
    const idInput = form.querySelector('input[name="id"]');
    if (idInput) idInput.value = variantId;

    // 2. Set or clear selling_plan
    let planInput = form.querySelector('input[name="selling_plan"]');
    if (!planInput) {
      planInput = document.createElement('input');
      planInput.type = 'hidden';
      planInput.name = 'selling_plan';
      form.appendChild(planInput);
    }
    planInput.value = planId;

    // 3. Sync the (hidden) <variant-radios> so image/URL/price update
    const picker = document.querySelector(
      `variant-radios[data-section="${this.sectionId}"], variant-selects[data-section="${this.sectionId}"]`
    );
    if (picker) {
      const matchingRadio = picker.querySelector(`input[type="radio"][value="${CSS.escape(variantOption)}"]`);
      if (matchingRadio && !matchingRadio.checked) {
        matchingRadio.checked = true;
        matchingRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (!matchingRadio) {
        const select = picker.querySelector('select');
        if (select) {
          select.value = variantOption;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    // 4. Force-enable the submit button (belt + suspenders — the theme
    //    should enable it via the variant-radios sync above, but if
    //    that didn't fire for any reason we want a working cart).
    const submitButtons = form.querySelectorAll('button[type="submit"], [name="add"]');
    submitButtons.forEach((btn) => {
      btn.removeAttribute('disabled');
      btn.classList.remove('disabled');
    });
  }
}

if (!customElements.get('plan-picker')) {
  customElements.define('plan-picker', PlanPicker);
}